import { Injectable } from '@angular/core';
import { TokenStorageService } from 'src/app/shared/auth/token/token-storage.service';

@Injectable({
  providedIn: 'root'
})
export class AuthorizationHeaderFactoryService {

  constructor(private tokenStorageService: TokenStorageService) { }

  createHeader() {
    const token = this.loadToken();
    return {
      Authorization: `Bearer ${token}`
    };
  }

  loadToken() {
    return this.tokenStorageService.loadToken();
  }
}
